import {I18n} from 'react-i18nify';
import contentDefinitionTypes from '../../config/contentDefinitionTypes';

const initialState = {
    items: [],
    select: [],
    selectPages: [],
    selectBlocks: [],
    selectWidgets: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'GLOBALS_RESET':
            return initialState;
        case 'GET_GLOBALS':
            const select = [];
            const selectPages = [];
            const selectBlocks = [];
            const selectWidgets = [];

            let items = [];

            if (action.payload.contentDefinitions) {
                action.payload.contentDefinitions.forEach((contentDefinition) => {
                    switch (contentDefinition.contentDefinitionType) {
                        case contentDefinitionTypes.BLOCK:
                            selectBlocks.push({
                                id: contentDefinition.id,
                                title: I18n.t('block.' + contentDefinition.key) + (contentDefinition.contentDefinitionLabel ? ' ('+ contentDefinition.contentDefinitionLabel +')' : ''),
                            });
                            break;
                        case contentDefinitionTypes.PAGE:
                        case contentDefinitionTypes.LISTING_PAGE:
                            selectPages.push({
                                id: contentDefinition.id,
                                title: I18n.t('content.' + contentDefinition.key)
                            });
                            break;
                        case contentDefinitionTypes.WIDGET:
                            selectWidgets.push({
                                id: contentDefinition.id,
                                title: I18n.t('content.' + contentDefinition.key)
                            });
                            break;
                        default:
                            break;
                    }

                    select.push({
                        id: contentDefinition.id,
                        title: contentDefinition.key
                    });
                });

                items = action.payload.contentDefinitions;
            }

            return {
                ...state,
                items: items,
                select: select,
                selectPages: selectPages,
                selectBlocks: selectBlocks,
                selectWidgets: selectWidgets
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/core/store/reducers/contentdefinition.js